import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HygineLinkComponent } from './hygine-link/hygine-link.component';
import { HygineLandingComponent } from './hygine-landing/hygine-landing.component';

const routes: Routes = [
   {
      path:'',component:HygineLinkComponent,
      children:[
        {
          path:'hygine',component:HygineLandingComponent
        },
      ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HygieneReportRoutingModule { }
